import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchAllReportCards = createAsyncThunk(
  `grades/fetchAllReportCards`,
  async (token, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "Content-type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${token}`,
        },
      };
      const { data } = await axios.get(
        `https://student.vstu.by/api/v1/student/grades/session`,
        config
      );

      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchReportCard = createAsyncThunk(
  `grades/fetchReportCard`,
  async ({ token, semester }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "Content-type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${token}`,
        },
      };
      const { data } = await axios.get(
        `https://student.vstu.by/api/v1/student/grades/session?semester=${semester}`,
        config
      );

      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchAllSemesters = createAsyncThunk(
  `grades/fetchAllSemesters`,
  async (token, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "Content-type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${token}`,
        },
      };
      const { data } = await axios.get(
        "https://student.vstu.by/api/v1/student/grades/semesters",
        config
      );

      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// export const fetchAverageSemesterGrade = createAsyncThunk(
//   `grades/fetchAverageSemesterGrade`,
//   async ({ token, semester }, { rejectWithValue }) => {
//     try {
//       const config = {
//         headers: {
//           "Content-type": "application/x-www-form-urlencoded",
//           Authorization: `Bearer ${token}`,
//         },
//       };

//       const { data } = await axios.get(
//         `https://student.vstu.by/api/grade/average/semester?semester=${semester}`,
//         config
//       );

//       return data;
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

const initialState = {
  reportCards: {},
  reportCardsStatus: null,
  reportCardsError: null,
  semesters: [],
  semestersStatus: null,
  semestersError: null,
  semesterAverageGrade: null,
  semesterAverageGradeStatus: null,
  semesterAverageGradeError: null,
};

const reportCardSlice = createSlice({
  name: "reportCards",
  initialState,
  reducers: {
    clearReportCards(state) {
      state.reportCards = {};
      state.reportCardsStatus = null;
      state.reportCardsError = null;
      state.semesters = [];
      state.semestersStatus = null;
      state.semestersError = null;
      state.semesterAverageGrade = null;
      state.semesterAverageGradeStatus = null;
      state.semesterAverageGradeError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllReportCards.pending, (state) => {
        state.reportCardsStatus = "loading";
        state.reportCardsError = null;
      })
      .addCase(fetchAllReportCards.fulfilled, (state, action) => {
        state.reportCardsStatus = "resolved";
        state.reportCards = action.payload;
        state.reportCardsError = null;
      })
      .addCase(fetchAllReportCards.rejected, (state, action) => {
        state.reportCardsStatus = "rejected";
        state.reportCardsError = action.payload;
      })
      .addCase(fetchAllSemesters.pending, (state) => {
        state.semestersStatus = "loading";
        state.semestersError = null;
      })
      .addCase(fetchAllSemesters.fulfilled, (state, action) => {
        state.semestersStatus = "resolved";
        state.semesters = action.payload;
        state.semestersError = null;
      })
      .addCase(fetchAllSemesters.rejected, (state, action) => {
        state.semestersStatus = "rejected";
        state.semestersError = action.payload;
      })
      .addCase(fetchReportCard.pending, (state) => {
        state.reportCardsStatus = "loading";
        state.reportCardsError = null;
      })
      .addCase(fetchReportCard.fulfilled, (state, action) => {
        state.reportCardsStatus = "resolved";
        state.reportCards = action.payload;
        state.reportCardsError = null;
      })
      .addCase(fetchReportCard.rejected, (state, action) => {
        state.reportCardsStatus = "rejected";
        state.reportCardsError = action.payload;
      });
    // .addCase(fetchAverageSemesterGrade.pending, (state) => {
    //   state.semesterAverageGradeStatus = "loading";
    //   state.semesterAverageGradeError = null;
    // })
    // .addCase(fetchAverageSemesterGrade.fulfilled, (state, action) => {
    //   state.semesterAverageGradeStatus = "resolved";
    //   state.semesterAverageGrade = action.payload;
    //   state.semesterAverageGradeError = null;
    // })
    // .addCase(fetchAverageSemesterGrade.rejected, (state, action) => {
    //   state.semesterAverageGradeStatus = "rejected";
    //   state.semesterAverageGradeError = action.payload;
    // });
  },
});

export const { clearReportCards } = reportCardSlice.actions;

export const reportCardsReducer = reportCardSlice.reducer;
